"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "FilePicker" */ './lazyIndex');
});
// Delay loaded components
exports.FileProviderView = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.FileProviderView; });
exports.FileProvidersToAddListView = owa_bundling_1.createLazyComponent(lazyModule, function (m) { return m.FileProvidersToAddListView; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/view/owa-filepicker-options-view/lib/index.js
// module id = 3733
// module chunks = 2